import { render } from "./Sidebar.vue?vue&type=template&id=2297cf86&scoped=true&bindings={\"activeClass\":\"data\",\"inactiveClass\":\"data\",\"menuItems\":\"data\"}"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"

import "./Sidebar.vue?vue&type=style&index=0&id=2297cf86&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2297cf86"

export default script